module.exports = __webpack_public_path__ + "img/Profile white.8ba2582b.svg";